import type { ReactNode } from 'react';
import { errorId, helpId } from '@/lib/field-attributes';

/**
 * Props for a labelled form field.
 *
 * @since 1.0.0
 */
export interface FormFieldProps {
    label: string;
    controlId: string;
    children: ReactNode;
    description?: ReactNode;
    error?: string | null;
}

/**
 * One row of a dialog form: the label, the control the caller supplies, the help line and
 * the error line. Callers spread `fieldControlProps` onto their control so the ids this
 * renders are the ids the control points at.
 *
 * @since 1.0.0
 * @param props - the label, the control id, the control itself and optional help and error copy
 * @returns the field element
 */
export function FormField({ label, controlId, children, description, error }: FormFieldProps) {
    const hasError = error !== null && error !== undefined && error !== '';

    return (
        <div className="fkwd-field">
            <label className="fkwd-field__label" htmlFor={controlId}>
                {label}
            </label>
            {children}
            {description === undefined ? null : (
                <p className="fkwd-field__help" id={helpId(controlId)}>
                    {description}
                </p>
            )}
            {hasError ? (
                <p className="fkwd-field__error" id={errorId(controlId)}>
                    {error}
                </p>
            ) : null}
        </div>
    );
}
